module.exports = __webpack_public_path__ + "img/COMBO PALM LIME.9935639.svg";